import { CustomExtender } from '#/CoreFrameInterfaces';

/**
 * Erweitert Knockout ume eine Async-Funktion
 * Nimmt einen Initialwert entgegen, der sofort im Observable verfübar ist
 */
export default class AsyncExtender implements CustomExtender {

    public AddToKnockout() {
        let extenders = ko.extenders;

        extenders.async = (target, initial) => {
            let type = _.isArray(initial) ? 'observableArray' : 'observable';
            let plainObservable = ko[type](initial), currentDeferred;

            plainObservable.inProgress = ko.observable(false);

            ko.computed(() => {
                if (currentDeferred) {
                    currentDeferred.reject();
                    currentDeferred = null;
                }

                let newDeferred = target() || initial;

                if (newDeferred && _.isFunction(newDeferred.done)) {
                    plainObservable.inProgress(true);

                    currentDeferred = $.Deferred().done((data) => {
                        plainObservable.inProgress(false);
                        plainObservable(data || initial);
                    });

                    newDeferred.done(currentDeferred.resolve);
                } else {
                    plainObservable(newDeferred);
                }
            });

            return plainObservable;
        };
    }

}